"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const SvgApple = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M20.357,7.082c-0.846,-1.094 -2.03,-2.082 -3.789,-2.082c-1.252,0 -2.301,1.159 -3.992,1.159c-1.354,0 -1.929,-1.159 -3.418,-1.159c-3.079,0 -6.158,2.801 -6.158,6.428c0,1.916 0.609,4.893 2.03,7.459c1.015,1.881 2.267,3.113 3.654,3.113c1.015,0 2.199,-0.924 3.62,-0.924c1.252,0 2.402,0.924 3.519,0.924c2.707,0 5.177,-3.593 5.177,-5.988c0,-0.137 -0.034,-0.445 -0.034,-0.445c-1.759,-0.957 -2.966,-2.36 -2.966,-4.413c0,-1.642 0.97,-3.079 2.289,-4.037l0.068,-0.035Zm-7.849,-1.334c2.03,-0.616 4.074,-2.162 3.891,-4.824c-0.017,-0.232 -0.102,-0.924 -0.102,-0.924c-2.064,0.582 -3.975,2.191 -3.891,4.756c0.01,0.32 0.102,0.992 0.102,0.992Z" })));
exports.default = SvgApple;
